import React, { useState } from 'react';
import DashboardWidgetNew from './DashboardWidgetNew';

const Repos = () => {
  const [filters, setFilters] = useState({});

  const getChartTitle = filters => {
    if (filters.operation === 'investment') {
      return 'Repo Based Investment Trend ($)';
    }
    if (filters.operation === 'git_effort') {
      return 'Repo Based Effort Trend';
    }
    return 'Repo Based Commit Trend';
  };

  const dashboardFilters = filter => {
    setFilters(filter);
  };

  return (
    <DashboardWidgetNew
      category="repos"
      dashboardFilters={dashboardFilters}
      isHidden={['repos']}
      forceClearMultiFilters={['repos']}
      title={{
        chartTitle: getChartTitle(filters),
        pieTitle: 'Repositories - Pie',
        tableColumnName: 'Repositories'
      }}
    />
  );
};

export default Repos;
